import { getFileIcon, sizeConversion } from "@/utils/index";
import { model } from 'eco-cli';
import moment from "moment";
const Image = model.Image;
const FileModel = model.File

export class Menu extends model.Model {
  id = "";
  title = "";
  desc = "";
  icon = "";
  bgSrc = "";
  fileType = ""; // 文件类型
  labelList = []; // 标签列表
  documentList = []; // 文件列表

  static blank() {
    return new this({});
  }

  static fromServer(json) {
    return Menu.new({
      id: json.id,
      title: json.name || '',
      desc: json.remark || '',
      icon: json.icon || '',
      bgSrc: json.bakImage || '',
      labelList: json.dirTagList?.map(v => InValue.new(v.name, v.id)),
      documentList: json.vipData?.map(v => Object.assign(
        File.new(v.id, v.title, v.publishTime, v.fileList),{
          pageviews: v.scanCount || 0,
          downCount: v.downCount || 0,
        }
      ))
    })
  }
}

export class MenuTree extends model.Model {
  id = "";
  title = "";
  childList = [];

  static blank() {
    return new this({});
  }

  static fromServer(json) {
    return MenuTree.new({
      id: json.id,
      title: json.name || '',
      childList: json.childList?.map(v => Menu.fromServer(v))
    })
  }
}

export class LabelFile extends model.Model {
  id = ""
  title = ""
  createTime = moment()
  fileList = []
  fileType = ""
  fileSize = 0
  viewCount = 0

  static blank() {
    return new this({});
  }

  static fromServer(json) {
    return LabelFile.new({
      id: json.id, 
      title: json.title, 
      createTime: moment(json.createTime).format("YYYY-MM-DD"), 
      viewCount: json.scanCount,
      fileType: json.fileList ? getFileIcon(json.fileList[0].fileSuffix).slice(1, json.fileList[0].fileSuffix.length) : 'file-unknown', 
      fileSize: json.fileList ? sizeConversion(json.fileList[0].fileSize) : ''
    })
  }
}
export class File extends model.Model {
  id = ""
  title = ""
  createTime = moment()
  fileList = []
  fileType = ""
  fileSize = 0
  scanCount = 0

  static new(id, title, createTime, fileList) {
    return id ? { id: id, title: title, createTime: moment(createTime).format("YYYY-MM-DD"), fileList: fileList, fileType: fileList ? getFileIcon(fileList[0].fileSuffix.slice(1, fileList[0].fileSuffix.length)) : 'file-article', fileSize: fileList ? sizeConversion(fileList[0].fileSize) : '' } : undefined
  }
}
export class InValue extends model.Model {
  label = "" // dict.name
  key = "" // dict.code
  title = ""

  static new(name, code) {
    return name ? { label: name, title: name, key: code } : undefined
  }
}

export class NewFile extends FileModel {
  fileSize = "";

  static blank() {
    return new this({});
  }

  constructor(json) {
    super();
    Object.assign(this, json)
  }

  static fromServer(json) {
    return new NewFile({
      ...json,
      ...super.fromServer(json),
      fileSize: sizeConversion(json.fileSize),
    });
  }
}

export class Article extends model.Model {
  static blank() {
    return new this({});
  }

  static fromServer(json) {
    return Article.new({
      articleId: json.id,
      title: json.title || "",
      publishDate: moment(json.publishTime).format('YYYY-MM-DD'),
      viewCount: json.scanCount,
      replyCount: json.discussCount,
      abstract: json.remark,
      content: json.html,
      isSupport: json.isThumb,
      vipType: json.vipType || 0,
      supportCount: json.thumbupCount || 0,
      showPageInnerBar: json.showPageInnerBar === '0'? false:true,
      image:
        json.fileList && json.fileList[0]
          ? Image.fromServer(json.fileList[0])
          : null,
      type: json.type,
      fileList: json.fileList ? (json.fileList.map((v) => NewFile.fromServer(v))) : [],
    });
  }

  articleId = "";
  title = "";
  publishDate = moment();
  viewCount = 0;
  replyCount = 0;
  supportCount = 0; // 点赞数
  abstract = ""; // 摘要
  content = "";
  isSupport = false; // 是否点赞
  type = '';
  fileList = [];
  showPageInnerBar = false
  vipType = ''
}

